import React, { useState } from "react";
import momenttz from "moment-timezone";
import { Typeahead } from "react-bootstrap-typeahead";
import { Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { setTimezone } from "../../Slices/sessionSlice";
function TimeZonePicker() {
  const dispatch = useDispatch();
  const {
    sessionUser: { timezone },
  } = useSelector((state) => state.sessionSlice);
  const [selectedTimezone, setSelectedTimezone] = useState([timezone]);
  console.log(timezone, "timezone");
  const options = momenttz.tz.names();
  const changeTimezone = (selectedTimezone) => {
    console.log("timezone", selectedTimezone);
    if (selectedTimezone[0]) {
      dispatch(setTimezone({ timezone: selectedTimezone[0] }));
    }
    setSelectedTimezone(selectedTimezone);
  };
  return (
    <Col>
      <span>Time Zone</span>
      <Typeahead
        id="basic-typeahead-single"
        onChange={changeTimezone}
        options={options}
        placeholder="Choose a state..."
        selected={selectedTimezone}
      />
    </Col>
  );
}

export default TimeZonePicker;
